import { render } from "./PackageSelector.vue?vue&type=template&id=16b6817c&bindings={\"activePack\":\"props\",\"getPackages\":\"options\",\"selectPackage\":\"options\"}"
import script from "./PackageSelector.vue?vue&type=script&lang=js"
export * from "./PackageSelector.vue?vue&type=script&lang=js"
script.render = render

export default script